import React, { useState, useEffect, useContext } from "react";
import * as S from "./styles";
import iconUser from "../../assets/user/account-circle.svg";
import Regional from "../../assets/navbar/Regional_on.svg";
import PessoaFisica from "../../assets/navbar/Pessoa_fisica_on_light_blue.svg";

import PessoaJuridica from "../../assets/navbar/Pessoa_juridica_on.svg";

import Convenios from "../../assets/navbar/Convenios_on.svg";
import Agentes from "../../assets/navbar/Agentes_on.svg";
import Lojas from "../../assets/navbar/Lojas_on.svg";
import Button from "../../components/Button";
import LupaOn from "../../assets/navbar/Lupa_on.svg";
import api from "../../services/api";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import { toast } from "react-toastify";
import { Context } from "../../context/globalContext";
import { mask } from "../../utils/mask";
import SkeletonListItem from "../SkeletonListItem";
import InputText from "../InputText";

import BorderForSelectNumberOfRecords from "../BorderForSelectNumberOfRecords";
import BorderForSort from "../BorderForSort";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";
import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../Button-v2";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function ListUser({ history, pageFilter, filter, name }) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { pageLimit, setPageLimit } = useContext(Context);

  const [users, setUsers] = useState([]);
  const [searchCPF, setSearchCPF] = useState("");
  const [searchName, setSearchName] = useState("");
  const [loading, setLoading] = useState(0);

  const [orderDirection, setorderDirection] = useState("ASC");
  const [orderByColumn, setorderByColumn] = useState("nome");
  const [sortIndex, setSortIndex] = useState(0);

  async function getDataByUserCpf(cpf, name, page) {
    try {
      setIsLoading(true);
      const response = await api.get(
        `api/usuarios/buscar?cpfCnpjOuNome=${desmaskIfNumber(cpf)}${
          name !== "" ? `&cnpjOuNome=${desmaskIfNumber(name)}` : ""
        }&page=${
          page || 0
        }&size=${pageLimit}&sort=${orderByColumn},${orderDirection}`
      );

      if (response && (response.status === 201 || response.status === 200)) {
        setUsers(response.data.content);
        setPage(page || 0);
        setTotalPages(response.data.totalPages);
        setTotalElements(response.data.totalElements);
      } else if (!response) {
        setPage(page || 0);
        setUsers([]);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Erro ao buscar aos usuarios.");
      }

      setIsLoading(false);
    } catch (err) {
      setPage(page || 0);
      setTotalPages(0);
      setTotalElements(0);
      setUsers([]);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar aos usuarios.");
      }
    }
  }

  useEffect(() => {
    if (filter) {
      setSearchCPF(desmaskIfNumber(filter));
    }

    if (name) {
      setSearchName(name);
    }

    if (pageFilter) {
      setPage(pageFilter);
    }

    loadUser(filter, name, pageFilter);
  }, [filter, name, pageFilter, pageLimit, sortIndex]);

  async function loadUser(cpf, name, page) {
    getDataByUserCpf(cpf, name, page);
  }

  const handleKeyPress = (event) => {
    const value = event.target.value;

    if (event.key === "Enter") {
      reloadPage(value);
    }
  };

  const reloadPage = (filter, page) => {
    history.replace(
      `?filter=${desmaskIfNumber(filter.searchCPF)}${
        filter.searchName !== "" ? `&person=${filter.searchName}` : ""
      }${page && page > 0 ? "&page=" + page : ""}`
    );
  };

  const selectNumberRegistry = async (item) => {
    setPageLimit(item.id);
  };

  const verifyIfIsEnabled = (pessoaJuridica, entity, image, url) => {
    if (!pessoaJuridica || pessoaJuridica === null) {
      return <S.SvgIconDisabled src={image} alt="" />;
    }

    if (
      pessoaJuridica &&
      (!pessoaJuridica?.tipoEntityPessoa ||
        pessoaJuridica?.tipoEntityPessoa === null)
    ) {
      return <S.SvgIconDisabled src={image} alt="" />;
    }

    if (pessoaJuridica && pessoaJuridica?.tipoEntityPessoa) {
      let pessoaJuridicaSearched = pessoaJuridica?.tipoEntityPessoa.find(
        (x) => x.papelPessoaJuridica === entity
      );
      if (pessoaJuridicaSearched && pessoaJuridicaSearched !== null) {
        return (
          <S.SvgIcon
            onClick={() => {
              history.push(`/${url}/${pessoaJuridica?.id}`);
            }}
            src={image}
            alt=""
          />
        );
      }
    }

    return <S.SvgIconDisabled src={image} alt="" />;
  };

  const selectSort = async (item) => {
    setSortIndex(item.id);

    switch (item.sort) {
      case "DESC":
        setorderByColumn("nome");
        setorderDirection("DESC");
        break;
      case "ASC":
        setorderByColumn("nome");
        setorderDirection("ASC");
        break;
      case "DataDESC":
        setorderByColumn("data_registro");
        setorderDirection("DESC");
        break;
      case "DataASC":
        setorderByColumn("data_registro");
        setorderDirection("ASC");
        break;
    }
  };

  return (
    <>
      <S.Container>
        <S.Card>
          <S.SearchWrapper>
            <div className="labelFilter">Filtrar pesquisa</div>

            <div className="boxSearch">
              <div className="wrapperInputButton">
                <div className="inputContainer">
                  <span className="inputWrapper">
                    <InputText
                      type="text"
                      name="searchCPF:"
                      label="CPF ou nome:"
                      alwaysShowMask={false}
                      autoComplete={"off"}
                      value={searchCPF}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onChange={(ev) => setSearchCPF(ev.target.value)}
                    />
                  </span>
                  <span className="inputWrapper">
                    <InputText
                      type="text"
                      name="searchCnpjNomeLoja"
                      label="CNPJ ou Nome da Loja:"
                      alwaysShowMask={false}
                      autoComplete={"off"}
                      value={searchName}
                      onKeyPress={(e) => handleKeyPress(e)}
                      onChange={(ev) => setSearchName(ev.target.value)}
                    />
                  </span>
                </div>
                <Button
                  type="button"
                  onClick={() => reloadPage({ searchCPF, searchName })}
                >
                  consultar
                </Button>
              </div>
            </div>
          </S.SearchWrapper>
          <S.CardHeader>
            <span>
              {`${totalElements} usuário${
                totalElements > 1 ? "s" : ""
              } cadastrado${totalElements > 1 ? "s" : ""} no sistema`}
            </span>
            {totalElements > 0 && (
              <span className="border">
                Selecione o icone para acessar o cadastro
              </span>
            )}
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {users &&
                users?.map((user) => {
                  return (
                    <>
                      <S.Custumer>
                        <S.Info
                          onClick={() =>
                            history?.push(`/cadastro-usuario/${user.id}`)
                          }
                        >
                          <img src={iconUser} alt="Icone usuário" />
                          <div className="dataCard">
                            <h4>CPF:</h4>
                            <h4>Nome:</h4>
                          </div>
                          <div className="dataCard">
                            <h4 className="h4-info">
                              {mask(user?.username, "###.###.###-##", true)}
                            </h4>
                            <h4 className="h4-info">{user?.pessoa?.nome}</h4>
                          </div>
                        </S.Info>

                        <div className="iconService">
                          <S.SvgIcon
                            onClick={() => {
                              if (!user?.pessoa || user?.pessoa === null) {
                                toast.error(
                                  "Este usuário não possui uma pessoa física vinculada!"
                                );
                                return;
                              }

                              history.push(
                                `/cadastro-pessoa-fisica/${user?.pessoa?.id}`
                              );
                            }}
                            src={PessoaFisica}
                            alt=""
                          />
                          <S.SvgIcon
                            onClick={() => {
                              if (
                                (user?.usuarioPapel &&
                                  !user?.usuarioPapel?.pessoa) ||
                                user?.usuarioPapel?.pessoa === null
                              ) {
                                toast.error(
                                  "Este usuário não possui uma pessoa jurídica vinculada!"
                                );
                                return;
                              }

                              history.push(
                                `/cadastro-pessoa-juridica/${user?.usuarioPapel?.pessoa?.id}`
                              );
                            }}
                            src={PessoaJuridica}
                            alt=""
                          />
                          {verifyIfIsEnabled(
                            user?.usuarioPapel?.pessoa,
                            "AGENTE",
                            Agentes,
                            "cadastro-agentes"
                          )}
                          {verifyIfIsEnabled(
                            user?.usuarioPapel?.pessoa,
                            "LOJA",
                            Lojas,
                            "cadastro-lojas"
                          )}
                          {verifyIfIsEnabled(
                            user?.usuarioPapel?.pessoa,
                            "REGIONAL",
                            Regional,
                            "cadastro-regionais"
                          )}
                          {verifyIfIsEnabled(
                            user?.usuarioPapel?.pessoa,
                            "CONVENIO",
                            Convenios,
                            `cadastro-convenios`
                          )}
                        </div>
                      </S.Custumer>
                    </>
                  );
                })}
              <div className="rodaPe">
                <div className="select1">
                  <S.SelectContainer>
                    <BorderForSelectNumberOfRecords
                      selected={0}
                      handleSearch={selectNumberRegistry}
                      initialValue={pageLimit}
                    />
                  </S.SelectContainer>
                </div>
                <div className="select">
                  <S.SelectContainer>
                    <BorderForSort
                      selected={0}
                      handleSearch={selectSort}
                      initialValue={sortIndex}
                    />
                  </S.SelectContainer>
                </div>
                <div className="select">
                  {totalPages > 1 && (
                    <TablePagination
                      component="div"
                      classes={{
                        toolbar: classes.toolbar,
                        caption: classes.caption,
                      }}
                      count={totalElements}
                      page={page}
                      labelDisplayedRows={({ from, to, count }) => {
                        return from + " - " + to + " de " + count;
                      }}
                      onPageChange={(p, newPage) =>
                        reloadPage({ searchCPF, searchName }, newPage)
                      }
                      rowsPerPageOptions={[]}
                      rowsPerPage={pageLimit}
                    />
                  )}
                </div>
              </div>
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Card>
      </S.Container>
    </>
  );
}
